import {alias, createModelSchema} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RewardBunch} from "@/modules/redactor/models/reward/RewardBunch";
import {LeagueKind} from "@/modules/redactor/models/leaderboard/LeagueKind";

export class LeagueConfig extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._kind = null;
        this._reward = null;
        this._achievement = null;

        this._segmentTop = 0;
        this._segmentMiddle = 0;
        this._segmentBottom = 0;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }


    get segmentTop() {
        return this._segmentTop;
    }

    set segmentTop(value) {
        this._segmentTop = value;
    }

    get segmentMiddle() {
        return this._segmentMiddle;
    }

    set segmentMiddle(value) {
        this._segmentMiddle = value;
    }

    get segmentBottom() {
        return this._segmentBottom;
    }

    set segmentBottom(value) {
        this._segmentBottom = value;
    }


    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    get achievement() {
        return this._achievement;
    }

    set achievement(value) {
        this._achievement = value;
    }

    valid() {

        if (!this.kind || LeagueKind.isNone(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.segmentTop) || this.segmentTop < 0) {
            return false;
        }

        if (!Number.isInteger(this.segmentMiddle) || this.segmentMiddle < 0) {
            return false;
        }

        if (!Number.isInteger(this.segmentBottom) || this.segmentBottom < 0) {
            return false;
        }

        if (!this.reward || this.reward.empty() || !this.reward.valid()) {
            return false;
        }

        if (!this.achievement || this.achievement.empty() || !this.achievement.valid()) {
            return false;
        }

        return true;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new LeagueConfig());
        } else if (target instanceof LeagueConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(LeagueConfig, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", LeagueKind.schema()),

    _segmentTop: alias("segment_top", Schema.primitive()),
    _segmentMiddle: alias("segment_middle", Schema.primitive()),
    _segmentBottom: alias("segment_bottom", Schema.primitive()),

    _reward: alias("reward", RewardBunch.schema()),
    _achievement: alias("achievement", RewardBunch.schema())
});